import { Fragment, React } from "react";
import { useSelector, useDispatch } from "react-redux";
import { CheckboxField, TextField, TextAreaField, View, Grid, Flex } from '@aws-amplify/ui-react';
import YesNo from '../anamnese_lib/YesNo';
import LeftAlignedRow from "../../lib/LeftAlignedRow";
import DatePicker from 'react-date-picker';
import { DatumToString } from "../../lib/DatumToString";
import StringToDate from "../../lib/StringToDate";
import { typedReturnValue } from '../anamnese_lib/validateInteger';

const BisherigerVerlauf = (props) => {
    // const [daten, setDaten] = useState(structuredClone(useSelector(state => state.anamnese.Daten)));
    const daten = useSelector(state => state.anamnese.Daten);
    const dispatch = useDispatch()

    const handleChange = (e) => {
        // console.log(e.target)
        const key = e.target.name;
        const val = typedReturnValue(key, e.target.value);
        dispatch({ type: 'anamnese/Modify', payload: { [key]: val } });

        props.handleChange(e);
    }

    const handleCheck = (e) => {
        const key = e.target.name;
        const val =e.target.value === 'on' ? 1 : 0; 
        dispatch({ type: 'anamnese/Modify', payload: {[key]: val} });

        props.handleChange(e);
    }

    const handleDate = (e) => {
        // console.log(e);
        const key = e.currentTarget.name;
        const ar = key.split('_');
        const val = DatumToString(e.currentTarget.value);
        const validated = val === 'NaN.NaN.NaN' ? '' : val;
        const ziel = [...daten[ar[0]]]
        ziel[e.currentTarget.index][ar[1]] = validated;
        dispatch({ type: 'anamnese/Modify', payload: { [ar[0]]: ziel } });

        props.handleChange({ target: { name: key, value: val } });
    }

    const handleTextArray = (e) => {
        // console.log(daten)
        const key = e.currentTarget.name;
        const ar = key.split('_');
        const val = e.currentTarget.value;
        const ziel = [...daten[ar[0]]]
        ziel[e.currentTarget.index][ar[1]] = val;
        dispatch({ type: 'anamnese/Modify', payload: { [ar[0]]: ziel } });

        props.handleChange({ target: { name: key, value: val } });
    }

    return (
        <>
            <h4>1.2 Bisheriger Verlauf Ihrer Erkrankung, die Anlass Ihrer Reha ist</h4>
            <h5>Wann sind die Beschwerden zum ersten Mal aufgetreten? Gab es ein auslösendes Ereignis?</h5>
            <TextAreaField
                name="BESCHW_VERLAUF"
                width="100%"
                defaultValue={daten.BESCHW_VERLAUF}
                onChange={handleChange}
                descriptiveText=""
                wrap="nowrap"
                maxLength={512}
                rows={3}
                readOnly={props.readOnly}
            />
            <p></p>
            <h5>Sind Untersuchungen erfolgt?</h5>
            <YesNo name="UNT_YN" value={daten.UNT_YN} onChange={handleChange} readOnly={props.readOnly} />
                {daten.UNT_YN === 1 &&
                    <>
            <LeftAlignedRow >
                        <CheckboxField
                            name="UNT_ROENTGEN"
                            value={daten.UNT_ROENTGEN === 1 ? "off" : "on"}
                            checked={daten.UNT_ROENTGEN === 1}
                            onChange={handleCheck}
                            label="Röntgen"
                            disabled={props.readOnly}
                        />
                        <CheckboxField
                            name="UNT_CT"
                            value={daten.UNT_CT === 1 ? "off" : "on"}
                            checked={daten.UNT_CT === 1}
                            onChange={handleCheck}
                            label="Computer Tomographie (CT)"
                            disabled={props.readOnly}
                        />
                        <CheckboxField
                            name="UNT_MRT"
                            value={daten.UNT_MRT === 1 ? "off" : "on"}
                            checked={daten.UNT_MRT === 1}
                            onChange={handleCheck}
                            label="Magnet Resonanz Tomographie (MRT)"
                            disabled={props.readOnly}
                        />
                        </LeftAlignedRow>
                        <LeftAlignedRow >

                        <CheckboxField
                            name="UNT_LAB"
                            value={daten.UNT_LAB === 1 ? "off" : "on"}
                            checked={daten.UNT_LAB === 1}
                            onChange={handleCheck}
                            label="Labor"
                            disabled={props.readOnly}
                        />
                        <CheckboxField
                            name="UNT_BEL_EKG"
                            value={daten.UNT_BEL_EKG === 1 ? "off" : "on"}
                            checked={daten.UNT_BEL_EKG === 1}
                            onChange={handleCheck}
                            label="Belastungs-EKG"
                            disabled={props.readOnly}
                        />
                        <CheckboxField
                            name="UNT_HERZ_KATH"
                            value={daten.UNT_HERZ_KATH === 1 ? "off" : "on"}
                            checked={daten.UNT_HERZ_KATH === 1}
                            onChange={handleCheck}
                            label="Herzkatheter"
                            disabled={props.readOnly}
                        />
            </LeftAlignedRow>
                    </>
                }
            {daten.UNT_YN === 1 &&
                <TextAreaField
                    name="UNT_SONST"
                    width="100%"
                    defaultValue={daten.UNT_SONST}
                    onChange={handleChange}
                    descriptiveText="Sonstige Untersuchungen:"
                    wrap="nowrap"
                    maxLength={512}
                    rows={3}
                    readOnly={props.readOnly}
                />
            }
            <p></p>{daten.NICHT_OP_T_YN === 1 ?
                <h5>Erfolgten nicht-operative Therapien wegen der genannten Beschwerden? Was war erfolgreich?</h5> :
                <h5>Erfolgten nicht-operative Therapien wegen der genannten Beschwerden?</h5>
            }

            <YesNo name="NICHT_OP_T_YN" value={daten.NICHT_OP_T_YN} onChange={handleChange} readOnly={props.readOnly} />
            <LeftAlignedRow>
                {daten.NICHT_OP_T_YN === 1 &&
                    <>
                        <CheckboxField
                            name="NICHT_OP_T_MEDI"
                            value={daten.NICHT_OP_T_MEDI === 1 ? "off" : "on"}
                            checked={daten.NICHT_OP_T_MEDI === 1}
                            onChange={handleCheck}
                            label="Medikamente"
                            disabled={props.readOnly}
                        />
                        <CheckboxField
                            name="NICHT_OP_T_KG"
                            value={daten.NICHT_OP_T_KG === 1 ? "off" : "on"}
                            checked={daten.NICHT_OP_T_KG === 1}
                            onChange={handleCheck}
                            label="Physiotherapie"
                            disabled={props.readOnly}
                        />
                    </>
                }
            </LeftAlignedRow>
            {daten.NICHT_OP_T_YN === 1 &&
                <TextAreaField
                    name="NICHT_OP_T_SONST"
                    width="100%"
                    defaultValue={daten.NICHT_OP_T_SONST}
                    onChange={handleChange}
                    descriptiveText="Sonstige Therapien:"
                    wrap="nowrap"
                    maxLength={512}
                    rows={3}
                    readOnly={props.readOnly}
                />
            }
            <p></p>
            <h5>Wurden wegen der bei 1.1 genannten Beschwerden Operationen durchgeführt?</h5>
            <YesNo name="OP_YN" value={daten.OP_YN} onChange={handleChange} readOnly={props.readOnly} />
            <p></p>
            {daten.OP_YN === 1 &&
                <Grid
                    columnGap="0.1rem"
                    rowGap="0.1rem"
                    templateColumns="1fr 5fr"
                >
                    <View>
                        <b>Datum</b>
                    </View>
                    <View>
                        <b>Welche Operation?</b>
                    </View>

                    {(daten.OPERATIONEN).map((element, index) => {
                        return (
                            <Fragment key={"F"+index}>
                                <Flex alignItems="center" key={"F_OPERATIONEN_DATUM_" + index}
                                >
                                    <DatePicker
                                        key={"OPERATIONEN_DATUM_" + index}
                                        name={"OPERATIONEN_DATUM_" + index}
                                        value={StringToDate(element.DATUM)}
                                        onChange={props.readOnly ? () => {} : (e) => handleDate({ currentTarget: { name: "OPERATIONEN_DATUM", index, value: e } })}
                                        locale="de-DE"
                                        format="dd.MM.y"
                                        maxDate={new Date()}
                                    />
                                </Flex>
                                <TextField
                                    key={"OPERATIONEN_ART_" + index}
                                    name={"OPERATIONEN_ART_" + index}
                                    maxLength={128}
                                    defaultValue={element.ART}
                                    onChange={props.readOnly ? () => {} : (e) => handleTextArray({ currentTarget: { name: "OPERATIONEN_ART", index, value: e.target.value } })}
                                    readOnly={props.readOnly}
                                />
                            </Fragment>
                        )
                    })}
                </Grid>
            }
            <p></p>
            <h5>Haben Sie bisher selbst etwas unternommen, um Ihre Beschwerden zu bessern?</h5>
            <YesNo name="SELBST_YN" value={daten.SELBST_YN} onChange={handleChange} readOnly={props.readOnly} />
            {daten.SELBST_YN === 1 &&
                <TextAreaField
                    name="SELBST"
                    width="100%"
                    descriptiveText="Was haben Sie unternommen?"
                    defaultValue={daten.SELBST}
                    onChange={handleChange}
                    wrap="nowrap"
                    maxLength={256}
                    rows={2}
                    readOnly={props.readOnly}
                />
            }
            <p></p>
            <h5>Kennen Sie die Ursachen für Ihre Erkrankung?</h5>
            <YesNo name="URSACHEN_YN" value={daten.URSACHEN_YN} onChange={handleChange} readOnly={props.readOnly} />
            {daten.URSACHEN_YN === 1 &&
                <TextAreaField
                    name="URSACHEN"
                    width="100%"
                    descriptiveText="Welche?"
                    defaultValue={daten.URSACHEN}
                    onChange={handleChange}
                    wrap="nowrap"
                    maxLength={256}
                    rows={2}
                    readOnly={props.readOnly}
                />
            }
            <p></p>
            <h5>Fühlen Sie sich über Ihre Erkrankung ausreichend informiert?</h5>
            <YesNo name="INFORMIERT_YN" value={daten.INFORMIERT_YN} onChange={handleChange} readOnly={props.readOnly} />
            {daten.INFORMIERT_YN === 0 && <TextAreaField
                name="INFORMIERT"
                width="100%"
                defaultValue={daten.INFORMIERT}
                onChange={handleChange}
                descriptiveText="Welche Informationen fehlen Ihnen?"
                wrap="nowrap"
                maxLength={256}
                rows={2}
                readOnly={props.readOnly}
            />
            }
        </>
    )
}

export default BisherigerVerlauf;
